import { observer } from "mobx-react-lite";
import { t } from "i18next";
import { useEffect, useState } from "react";
import * as S from "./style";
import { Icon } from "@smartsuite/react-ui/lib";
import { SolutionColorVariables } from "@smartsuite/types";

export const DropdownOnboardingHelp = observer<{
  helpText: string;
  variableName: string;
  onButtonClick?: () => void;
}>(({ helpText, variableName, onButtonClick }) => {
  const [isShowHelpText, setIsShowHelpText] = useState<boolean>(false);

  const onHideClick = (): void => {
    localStorage.setItem(variableName, "true");
    setIsShowHelpText(false);
    onButtonClick?.();
  };

  useEffect(() => {
    if (localStorage.getItem(variableName) === null) {
      setIsShowHelpText(true);
    }
  }, [variableName]);
  return isShowHelpText ? (
    <S.DropdownHelpWrapper>
      <S.DropdownHelpInner>
        <S.HelpLogoWrapper>
          <Icon
            name="question"
            size="M"
            color={SolutionColorVariables.sc1}
            dimension={{ width: 20, height: 20 }}
          />
        </S.HelpLogoWrapper>
        <div>
          <S.HelpText>{helpText}</S.HelpText>

          <S.HideButton onClick={onHideClick}>
            {t("dropdown-help-onboarding.hide-link-text")}
          </S.HideButton>
        </div>
      </S.DropdownHelpInner>
    </S.DropdownHelpWrapper>
  ) : null;
});
